export default "__VITE_ASSET__BdN4eYBu__"